export default __webpack_public_path__ + "static/media/error-mail.4ad5831e.svg";